/*
  Expandable Footer Links Component
  - Instant toggle with no animations or auto-scrolling
  - Proper accessibility support
*/

(function() {
  'use strict';

  function initExpandableFooter() {
    const expandableFooter = document.getElementById('expandable-footer');
    
    if (!expandableFooter) {
      return;
    }

    const toggleButton = expandableFooter.querySelector('.expandable-footer__toggle-btn');
    
    if (!toggleButton) {
      console.warn('Expandable Footer: Toggle button not found');
      return;
    }

    function handleToggle(event) {
      event.preventDefault();
      
      const isCurrentlyExpanded = expandableFooter.classList.contains('is-expanded');
      expandableFooter.classList.toggle('is-expanded');
      const isNowExpanded = !isCurrentlyExpanded;

      // Update ARIA attributes
      toggleButton.setAttribute('aria-expanded', String(isNowExpanded));
      
      // Dispatch custom event for extensibility
      expandableFooter.dispatchEvent(new CustomEvent('expandableFooter:toggle', {
        detail: { expanded: isNowExpanded },
        bubbles: true
      }));
    }

    toggleButton.addEventListener('click', handleToggle);

    return function cleanup() {
      toggleButton.removeEventListener('click', handleToggle);
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExpandableFooter);
  } else {
    initExpandableFooter();
  }

})();